import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import { PAYMENTS_MENUS } from '../Layout/menu-names'
// import './approval.css'
import DashboardService from '../../services/dashboard.service'
import { HISTORY_SUB_MENUS } from '../../api/menu-details'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import { useTranslation } from 'react-i18next';

export default function History() {
  const history = useHistory()
  const [subMenuList, setSubMenuList] = useState([])
  const {t}=useTranslation()

  useEffect(() => {
    getSubMenus()
    return () => {}
  }, [])

  const getSubMenus = useCallback(async () => {
    try {
      const response = await DashboardService.getSubMenus('COMPLETED')
      if (response.status === 200) {
        console.log(response.data)
        setSubMenuList(response.data)
      }
    } catch (err) {}
  }, [])

  return (
    <LayoutWithOutAccountCard keyPath={'HISTORY'} showEmptySpace={true} breadCumKey='HISTORY'>
      <Row>
        {subMenuList.map((option, index) => (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() => history.push(HISTORY_SUB_MENUS.LINKS[option?.screenCode])}>
            <img width={46} height={40} src={HISTORY_SUB_MENUS.ICONS[option?.screenCode]} />
            <h2>{t(HISTORY_SUB_MENUS.TITLE[option?.screenCode])}</h2>
            {/* <span>{option?.desc}</span> */}
          </Col>
        ))}
      </Row>
    </LayoutWithOutAccountCard>
  )
}
